import {atomWithStorage} from 'jotai/utils';
import {JiraTicketTabId} from 'views/home/dashboard/dashboardModel';

/** Which tab the Jira tile opens on when both Assigned and Created have tickets. */
export const jiraDefaultTabAtom = atomWithStorage<JiraTicketTabId>(
  'dashboard:jiraDefaultTab:v1',
  'assigned'
);
